import { Chat_content } from "../../../Components/MessageApp/MessagesInterfaces";

import Leila from "../Area51Assets/Avatars/Leila-pfp.webp";
import Natalia from "../Area51Assets/Avatars/NataliaRound.webp";
import Mom from "../Area51Assets/Avatars/Mom-pfp.webp";
import mervi from "../Area51Assets/Avatars/Spam Texts Profile pic.jpg";

export const Area51MessageContent: Chat_content[] = [
  {
    icon: Natalia,
    name: "Natalia",
    type: "individual",
    read: true,
    messages: [
      {
        content: {
          type: "missed-call",
          content: "Missed call (4:36pm)",
        },
        timestamp: "2024-09-08T16:36:00.000Z",
        from: "Natalia",
      },
      {
        content: {
          type: "missed-call",
          content: "Missed call (4:37pm)",
        },
        timestamp: "2024-09-08T16:37:00.000Z",
        from: "Natalia",
      },
      {
        content: {
          type: "missed-call",
          content: "Missed call (4:38pm)",
        },
        timestamp: "2024-09-08T16:38:00.000Z",
        from: "Natalia",
      },
      {
        content: {
          type: "text",
          content:
            "Noémie, please answer my calls… we need to back out of this… I’ve just been threatened at gunpoint in my own house… and they threatened Otis at gunpoint on Thursday…",
        },
        timestamp: "2024-09-08T16:39:00.000Z",
        from: "Natalia",
      },
      {
        content: {
          type: "text",
          content: "omg Nat that's so frightening are you ok?",
        },
        timestamp: "2024-09-08T16:41:00.000Z",
        from: "Noémie",
      },
      {
        content: {
          type: "text",
          content:
            "If anything gets leaked, they're gonna kill me, you, Otis, my kids. They're gonna kill all of us",
        },
        timestamp: "2024-09-08T16:41:00.000Z",
        from: "Natalia",
      },
      {
        content: {
          type: "text",
          content: "I'm so sorry they did this to your family natty",
        },
        timestamp: "2024-09-08T16:43:00.000Z",
        from: "Noémie",
      },
      {
        content: {
          type: "text",
          content:
            "It’s not worth the risk Noémie. I think it’s the CIA. They know about everything. They want to see evidence we've destroyed the USBs.",
        },
        timestamp: "2024-09-08T16:44:00.000Z",
        from: "Natalia",
      },
      {
        content: {
          type: "text",
          content:
            "Ok ok let's calm down it's gonna be ok... thank god you're all alive",
        },
        timestamp: "2024-09-08T16:45:00.000Z",
        from: "Noémie",
      },
      {
        content: {
          type: "text",
          content: "you need to destroy the USBs Noémie it’s the only way",
        },
        timestamp: "2024-09-08T16:46:00.000Z",
        from: "Natalia",
      },
      {
        content: {
          type: "text",
          content:
            "Nat you know we can't do that. Think of how many lives we can save",
        },
        timestamp: "2024-09-08T16:47:00.000Z",
        from: "Noémie",
      },
      {
        content: {
          type: "text",
          content: "Noemie we have to, for Otis sake, for my family",
        },
        timestamp: "2024-09-08T16:48:00.000Z",
        from: "Natalia",
      },
      {
        content: {
          type: "text",
          content:
            "You know I care a lot about your family but I really can't let you do this",
        },
        timestamp: "2024-09-08T16:48:00.000Z",
        from: "Noémie",
      },
      {
        content: {
          type: "text",
          content: "you really won't destroy the USB to save us?",
        },
        timestamp: "2024-09-08T16:48:00.000Z",
        from: "Natalia",
      },
      {
        content: { type: "text", content: "I'm sorry Nat I just can't." },
        timestamp: "2024-09-08T16:48:00.000Z",
        from: "Noémie",
      },
    ],
  },
  {
    icon: Leila,
    name: "Leila",
    type: "individual",
    read: true,
    messages: [
      {
        content: { type: "text", content: "I've just read your letter" },
        timestamp: "2024-09-08T16:38:00.000Z",
        from: "Leila",
      },
      {
        content: {
          type: "text",
          content:
            "after everything we had together i'm really upset that u feel like that and to be perfectly honest i’m offended and angry that u chose to write me a letter instead of talking it through with me",
        },
        timestamp: "2024-09-08T21:44:00.000Z",
        from: "Leila",
      },
      {
        content: {
          type: "text",
          content:
            "i don’t want to even try explain how i feel about you right now cos it’s not good",
        },
        timestamp: "2024-09-08T21:44:00.000Z",
        from: "Leila",
      },
      {
        content: {
          type: "text",
          content: "you’re actually such a bitch you know that?",
        },
        timestamp: "2024-09-08T22:37:00.000Z",
        from: "Leila",
      },
      {
        content: { type: "text", content: "i hate you" },
        timestamp: "2024-09-08T22:42:00.000Z",
        from: "Leila",
      },
      {
        content: { type: "text", content: "stop ignoring me" },
        timestamp: "2024-09-08T22:55:00.000Z",
        from: "Leila",
      },
      {
        content: { type: "text", content: "i don't understand" },
        timestamp: "2024-09-08T23:19:00.000Z",
        from: "Leila",
      },
      {
        content: { type: "text", content: "i love oyu" },
        timestamp: "2024-09-08T23:25:00.000Z",
        from: "Leila",
      },
      {
        content: { type: "text", content: "ahsbpg" },
        timestamp: "2024-09-08T23:48:00.000Z",
        from: "Leila",
      },
      {
        content: { type: "text", content: "oops i misspelt thag" },
        timestamp: "2024-09-08T23:52:00.000Z",
        from: "Leila",
      },
      {
        content: { type: "text", content: "t" },
        timestamp: "2024-09-09T00:11:00.000Z",
        from: "Leila",
      },
      {
        content: {
          type: "text",
          content: "don’t even know what that was supposed to say looooooool",
        },
        timestamp: "2024-09-09T00:11:00.000Z",
        from: "Leila",
      },
      {
        content: {
          type: "text",
          content:
            "I feared you would react like this. I really think it would be best if we take some time apart from each other for a bit and we can talk about things properly when these initial feelings have blown over. Of course it’s difficult because we work together but we can still try our best can’t we? I’m sorry 😔",
        },
        timestamp: "2024-09-09T21:41:00.000Z",
        from: "Noémie",
      },
    ],
  },

  {
    icon: Mom,
    name: "Mom",
    type: "individual",
    read: true,
    messages: [
      {
        content: {
          type: "text",
          content:
            "Just got my PTO approved so I'll be home for Christmas this year! 😁",
        },
        timestamp: "2024-09-06T15:31:00.000Z",
        from: "Noémie",
      },
      {
        content: {
          type: "text",
          content:
            "Thats wonderful news, we're all looking forward to seeing you",
        },
        timestamp: "2024-09-06T15:42:00.000Z",
        from: "Mom",
      },
      {
        content: { type: "text", content: "We will see you then love x" },
        timestamp: "2024-09-06T15:43:00.000Z",
        from: "Mom",
      },
    ],
  },
  {
    icon: mervi,
    name: "Mevri",
    type: "individual",
    read: true,
    messages: [
      {
        content: { type: "text", content: "Your parcel has been delivered." },
        timestamp: "2024-08-19T10:43:00.000Z",
        from: "Mevri",
      },
    ],
  },
];
